<template lang="pug">
  section(class="section")
    .columns
      .column.is-half
        b-field(:type="{'is-danger': errors.has('sales_person_id')}" :message="errors.first('sales_person_id')")
          b-field(horizontal label="営業担当(必須)" custom-class="label-box")
            b-select(
              v-validate="'required'"
              data-vv-as="営業担当"
              data-vv-name="sales_person_id"
              v-model="sales_person_id"
              )
              option(
                v-for="sales_person in sales_people"
                :value="sales_person.id"
                :key="sales_person.id"
              )
                | {{ sales_person.name }}
        agency-shop-code-input(
          input_name="agency_shop_code"
          :agency_shop_code.sync="agency_shop_code"
          :agency_code.sync="agency_code"
          :agencies="agencies"
          :final_book_shop_agencies="final_book_shop_agencies"
          vertical
          )
        b-field
        b-field(horizontal label="自由入力\n\n・書店名\n ・番線\n・郵便番号\n・住所\n・電話番号\n・担当者\n・書店の発注担当者\n(送付先名が異なる場合)\nなど" custom-class="label-box free-text")
          textarea(class="textarea" rows="10"
              v-model="bibo"
              data-vv-as="自由入力\n\n- 書店名\n- 住所\n- 電話番号\nなど"
          )
        b-field(horizontal label="宛名(担当者○○様宛に送ってもらいたい場合）" custom-class="label-box free-text")
          b-input(
            type="string"
            size="is-small"
            v-model="shop_person"
            data-vv-as="書店担当"
          )
        b-field(horizontal label="受注経路" custom-class="label-box")
          b-select(v-model="order_route_id")
            option(
              v-for="route in accepting_order_routes"
              :value="route.id"
              :key="route.id"
            )
              | {{ route.name }}
      .column
        b-table(class="table fixed"
          :data="accepting_draft_order_items"
          narrowed
          hoverable
          striped
        )
          template(slot-scope="props")
            b-table-column(field="isbn" label="書籍名 : ISBN" width="250" class="text-compact")
              isbn-input(
                :input_name="'isbn' + props.row.i"
                v-model="props.row.isbn"
                :books="books"
                :errors="[]"
                :disabled="isDestroy(props.row)"
              )
            b-table-column(field="order_number" label="冊数" width="10")
             b-field(:type="{'is-danger': errors.has('order_number' + props.row.i)}" :message="errors.first('order_number' + props.row.i)")
                b-input(
                  :data-vv-name="'order_number' + props.row.i"
                  type="number"
                  size="is-small"
                  v-model="props.row.order_number"
                  v-validate="!isDestroy(props.row) ? 'required|min_value:1' : ''"
                  data-vv-as="冊数"
                  :disabled="isDestroy(props.row)"
                )
            b-table-column(field="" label="" width="40")
              b-field
                a.delete(@click="clickDeleteButton(props.row)")
        .control
          button(@click="addRow" class="button is-info")
            b-icon(pack="fas" custom-class="fa-sm fa-th-list")
            span
              | 1 行追加

    .columns.is-centered
      .column.is-half
        .field
          .control
            button(@click="submit" class="button is-medium is-danger is-fullwidth")
              | 登録
    b-loading(:is-full-page="true" :active.sync="loading" :can-cancel="false")
</template>

<script>
  import CacheDispatcher from 'mixins/cache_dispatcher'
  import ErrorDisplayer from 'mixins/error_displayer'
  import SalesPersonIdInput from 'inputs/sales_person_id_input'
  import AgencyShopCodeInput from 'inputs/agency_shop_code_input'
  import IsbnInput from 'inputs/isbn_input'
  import AcceptingOrderRouteIdInput from 'inputs/accepting_order_route_id_input'
  import AcceptingOrderItem from 'models/accepting_order_item'
  import { Validator } from "vee-validate"

  export default {
    name: 'accepting-draft-order-form',
    components: {
      SalesPersonIdInput,
      IsbnInput,
      AcceptingOrderRouteIdInput,
      AgencyShopCodeInput
    },
    mixins: [CacheDispatcher, ErrorDisplayer],
    $_veeValidate: {
      validator: 'new'
    },
    data() {
      return {
        accepting_draft_order: {},
        accepting_draft_order_items: [],
        sales_person_id: null,
        agency_code: '',
        agency_shop_code: '',
        shop_person: null,
        bibo: null,
        order_route_id: null,
        loading: false,
      }
    },
    computed: {
      sales_people(){ return this.$store.getters['SalesPeople/records'] },
      books(){  return this.$store.getters['Books/records'] },
      agencies(){ return this.$store.getters['Agencies/records'] },
      final_book_shop_agencies(){ return this.$store.getters['FinalBookShopAgencies/records'] },
      accepting_order_routes(){ return this.$store.getters['AcceptingOrderRoutes/records'] },
    },
    methods: {
      initAcceptingDraftOrderItems() {
        this.accepting_draft_order_items.push(Object.assign({}, new AcceptingOrderItem()))
      },
      addRow() {
        this.accepting_draft_order_items.push(Object.assign({}, new AcceptingOrderItem()))
      },
      submit() {
        this.loading = true
        this.$validator.validateAll().then((result) => {
          if(result) {
            this.submitRequest().then(({data}) => {
              this.loading = false
              window.location.href = `/users/accepting_draft_orders/${data.accepting_draft_order.id}/edit`
            })
            .catch((error) => {
              this.loading = false
              throw error
            })
          } else {
            this.loading = false
            this.$toast.open({
              message: '登録情報にエラーがあります。',
              type: 'is-danger',
              position: 'is-bottom'
            })
          }
        })
      },
      submitRequest(){
        let method = 'post'
        let url = `/api/v1/accepting_draft_orders.json`
        let params = this.createParams()
        return this.$http({ method: method, url: url, data: params })
      },
      createParams() {
        this.accepting_draft_order_items.forEach((item) => {
          item.sales_person_id = this.sales_person_id
          item.agency_code = this.agency_code
          item.agency_shop_code = this.agency_shop_code
          item.bibo = this.bibo
          item.shop_person = this.shop_person
          item.order_route_id = this.order_route_id
        })
        let params = {
          accepting_order: {
            direct_flag: true,
            accepting_order_items_attributes: this.accepting_draft_order_items
          }
        }
        return params
      },
      clickDeleteButton(row){
        if(row._destroy == null) {
          row._destroy = '1'
        }else {
          row._destroy = null
        }
      },
      isDestroy(row){
        return row._destroy == "1"
      },
    },
    created() {
      this.dispatch_with_cache('SalesPeople/fetch', 'sales_people', this.sales_people)
      this.dispatch_with_cache('Agencies/fetch', 'agencies', this.agencies)
      this.dispatch_with_cache('FinalBookShopAgencies/fetch', [ 'final_book_shop_agencies', null, { query: 'mode=simple' }], this.final_book_shop_agencies)
      this.$store.dispatch('Books/fetch', 'books')
      this.dispatch_with_cache('AcceptingOrderRoutes/fetch', 'accepting_order_routes', this.accepting_order_routes)
      this.initAcceptingDraftOrderItems()
    }
  }
</script>

<style>
  .field .label-box.free-text label.label{
    white-space: pre;
  }
</style>
<style scoped>
  .label-box {
    background-color: #464e59;
    color: #fff;
    padding-right: 5px;
  }
</style>
